/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RecipientProviderType } from './RecipientProviderType';
import {
    RecipientProviderTypeFromJSON,
    RecipientProviderTypeFromJSONTyped,
    RecipientProviderTypeToJSON,
    RecipientProviderTypeToJSONTyped,
} from './RecipientProviderType';

/**
 * 
 * @export
 * @interface UpdateReferralRecipientConfigRequest
 */
export interface UpdateReferralRecipientConfigRequest {
    /**
     * 
     */
    provider_id?: string;
    /**
     * Set only for recipients without a provider_id. Send null for Other; omit to leave the current facility type unchanged.
     */
    provider_type?: RecipientProviderType | null;
    /**
     * 
     */
    display_name?: string;
    /**
     * Required unless provider_id resolves to an internal (ExaCare) provider, in which case it may be omitted and resolved from contact_id instead.
     */
    email?: string;
    /**
     * 
     */
    phone?: string;
    /**
     * 
     */
    notes?: string;
    /**
     * Provider directory contact to resolve this recipient's email from at send time. Only applicable when provider_id resolves to an internal (ExaCare) provider; the contact must be contact_type 'inbound' for that provider.
     */
    contact_id?: string;
    /**
     * Fax number to deliver referrals to via eFax, in addition to the required email address.
     */
    fax?: string;
}



/**
 * Check if a given object implements the UpdateReferralRecipientConfigRequest interface.
 */
export function instanceOfUpdateReferralRecipientConfigRequest(value: object): value is UpdateReferralRecipientConfigRequest {
    return true;
}

export function UpdateReferralRecipientConfigRequestFromJSON(json: any): UpdateReferralRecipientConfigRequest {
    return UpdateReferralRecipientConfigRequestFromJSONTyped(json, false);
}

export function UpdateReferralRecipientConfigRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReferralRecipientConfigRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'provider_id': json['provider_id'] == null ? undefined : json['provider_id'],
        'provider_type': json['provider_type'] === undefined ? undefined : json['provider_type'] === null ? null : RecipientProviderTypeFromJSON(json['provider_type']),
        'display_name': json['display_name'] == null ? undefined : json['display_name'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'contact_id': json['contact_id'] == null ? undefined : json['contact_id'],
        'fax': json['fax'] == null ? undefined : json['fax'],
    };
}

export function UpdateReferralRecipientConfigRequestToJSON(json: any): UpdateReferralRecipientConfigRequest {
    return UpdateReferralRecipientConfigRequestToJSONTyped(json, false);
}

export function UpdateReferralRecipientConfigRequestToJSONTyped(value?: UpdateReferralRecipientConfigRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'provider_id': value['provider_id'],
        'provider_type': RecipientProviderTypeToJSON(value['provider_type']),
        'display_name': value['display_name'],
        'email': value['email'],
        'phone': value['phone'],
        'notes': value['notes'],
        'contact_id': value['contact_id'],
        'fax': value['fax'],
    };
}

